<script lang="ts">
  /**
   * STANDARDIZED TEXT INPUT
   *
   * Usage:
   * <Input label="Email" type="email" bind:value={email} error={errors.email} />
   */
  interface Props {
    label: string;
    type?: 'text' | 'email' | 'password' | 'number';
    placeholder?: string;
    value?: string;
    error?: string | null;
    disabled?: boolean;
    id?: string;
    oninput?: (e: Event) => void;
  }

  let {
    label,
    type = 'text',
    placeholder = '',
    value = $bindable(''),
    error = null,
    disabled = false,
    id = label.toLowerCase().replace(/\s+/g, '-'),
    oninput,
  }: Props = $props();
</script>

<div class="flex flex-col gap-1.5">
  <label for={id} class="text-sm font-medium text-surface-300">{label}</label>
  <input
    {id}
    {type}
    {placeholder}
    {disabled}
    {oninput}
    bind:value
    class="w-full px-4 py-2.5 rounded-lg bg-surface-800 border text-surface-100
           placeholder-surface-500 transition-colors duration-200
           focus:outline-none focus:ring-2 focus:ring-brand-500/50 focus:border-brand-500
           disabled:opacity-50 disabled:cursor-not-allowed
           {error ? 'border-red-500' : 'border-surface-600 hover:border-surface-500'}"
  />
  {#if error}
    <p class="text-xs text-red-400 mt-0.5">{error}</p>
  {/if}
</div>
